import { render, staticRenderFns } from "./CallEditPhoneIssues.vue?vue&type=template&id=656105d2"
import script from "./CallEditPhoneIssues.vue?vue&type=script&lang=js"
export * from "./CallEditPhoneIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports